import classNames from 'classnames/bind';
import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import { TFunction } from 'next-i18next';

import React, { useState } from 'react';

import { Button } from '@thinkific/chalk';
import { Icon } from '@thinkific/chalk/react-icons';

import styles from 'components/EmojiPicker/EmojiPicker.module.scss';
import getDictionary from 'components/EmojiPicker/EmojiPickerDictionary';

const cx = classNames.bind(styles);

interface EmojiPickerProps {
  icon: Icon;
  /** Position of the emoji picker modal in relation to the emoji button * */
  position?: 'right' | 'left';
  t: TFunction;
  onPick(emoji: string): void;
  disabled?: boolean;
  onTrackClick: () => void;
}

const EmojiPicker = ({
  icon,
  onPick,
  position = 'right',
  t,
  disabled,
  onTrackClick,
}: EmojiPickerProps) => {
  const [isPickerDisplayed, setIsPickerDisplayed] = useState(false);
  const handleSelect = (emoji) => {
    const { native } = emoji;
    // eslint-disable-next-line no-unused-expressions
    native && onPick(native);
    handleDismiss();
  };

  const handleDismiss = () => {
    setIsPickerDisplayed(false);
  };

  const togglePicker = () => {
    if (!isPickerDisplayed) {
      onTrackClick();
    }
    setIsPickerDisplayed((prev) => !prev);
  };

  return (
    <div className={cx('emoji-picker')} data-qa="emoji-picker">
      <Button
        disabled={disabled}
        emphasis="low"
        icon={icon}
        size="sm"
        hiddenLabel
        onClick={togglePicker}
      >
        Emoji
      </Button>
      <div
        className={cx('emoji-picker__emoji-mart', `emoji-picker__emoji-mart--${position}`)}
        data-qa="emoji-picker__emoji-mart"
      >
        {isPickerDisplayed && (
          <>
            <div
              aria-label={t('Close emoji picker')}
              className={cx('emoji-picker__overlay')}
              role="button"
              tabIndex={0}
              onClick={handleDismiss}
              onKeyPress={handleDismiss}
            />
            <Picker
              i18n={getDictionary(t)}
              showPreview={false}
              showSkinTones={false}
              autoFocus
              emojiTooltip
              native
              onSelect={handleSelect}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default EmojiPicker;
